<dx-scroll-view>
  <section id="cd-timeline" class="cd-container">
    <div *ngFor="let item of poiList; let i = index" class="cd-timeline-block">
      <div class="cd-timeline-img"></div>

      <div class="cd-timeline-content p-2 bg-gray-100 hover:bg-gray-200">
        <div class="p-2" [ngStyle]="{borderLeft: '5px solid '+ item.poi.color}">
          <h5>#{{i+1}}, {{item.enter_time | date :'shortTime'}} - {{item.exit_time | date :'shortTime'}}, {{item.poi.name}}</h5>
          <div class="flex items-center text-xs text-gray-600 mt-3">
            <p title="Temps d'Arrêt" class="flex items-center">
              <ic-icon class="mr-1" height="20px" width="20px" [icon]="stopDurationIcon" [inline]="true"></ic-icon>
              {{durationToStr(item.visit_duration, true)}}</p>
            <p class="px-3">•</p>
            <p title="Distance" class="flex items-center">
              <ic-icon class="mr-1" height="20px" width="20px" [icon]="distanceIcon" [inline]="true"></ic-icon> {{item.metrics.length_in_km | number}} km</p>
            <p class="px-3">•</p>
            <p title="Heures Moteurs" class="flex items-center">
              <ic-icon class="mr-1" height="20px" width="20px" [icon]="engineWorkTimeIcon" [inline]="true"></ic-icon> {{item.metrics.engine_working_hours | number}} h</p>
            <p class="px-3">•</p>
            <p title="Consomation Carburant" class="flex items-center"><ic-icon class="mr-1" height="20px" width="20px" [icon]="fuelTotalConsumptionIcon" [inline]="true"></ic-icon>
              {{item.metrics.fuel_total_consumption | number}} L ({{item.metrics.fuel_hourly_consumption_rate_avg | number}} L/h)</p>
            <p class="px-3">•</p>
            <p title="Temperature Carburant" class="flex items-center"><ic-icon class="mr-1" height="20px" width="20px" [icon]="fuelTemperatureIcon" [inline]="true"></ic-icon>
              {{item.metrics.fuel_temperature_avg | number}} °C</p>
            <p class="px-3">•</p>
            <p title="Vitesse" class="flex items-center"><ic-icon class="mr-1" height="20px" width="20px" [icon]="speedAvgIcon" [inline]="true"></ic-icon>
              {{item.metrics.speed_avg | number}} <span title="Vitesse Maximale"> ({{item.metrics.speed_max | number}}) </span> km/h</p>
          </div>
        </div>
      </div>  <!--cd-timeline-content -->
    </div> <!-- cd-timeline-block -->
  </section> <!-- cd-timeline -->
</dx-scroll-view>
